var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useQuery } from "react-query";
import { AvailabilityCalculationService } from "../../../services/availability/availabilityCalculation.service";
import { sortAvailabilitiesByAvailabilityType } from "../reservations/calendar/calendar.util";
import { AvailabilityService } from "../../../services/availability/availability.service";
import { AvailabilityExceptionService } from "../../../services/availability/availabilityException.service";
export var useAvailability = function (resourceIds) {
    // We need to refetch when fromDate changes as well
    return useQuery(['availability', resourceIds], function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, AvailabilityService.getAllAvailabilities({
                        limit: {
                            offset: 0,
                            // CAUTION - limit should be higher depending on the seed data pool, for demo purposes we leave it like this
                            limit: 500,
                            sort: [{ field: "id", direction: "DESC" }]
                        },
                        entityIds: resourceIds
                    })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.content || []];
            }
        });
    }); });
};
export var useAvailabilities = function (ids) {
    // We need to refetch when fromDate changes as well
    return useQuery(['availability', ids], function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, AvailabilityService.getAllAvailabilities({
                        limit: {
                            offset: 0,
                            // CAUTION - limit should be higher depending on the seed data pool, for demo purposes we leave it like this
                            limit: 1000,
                            sort: [{ field: "id", direction: "DESC" }]
                        },
                        id: ids,
                    })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.content || []];
            }
        });
    }); });
};
export var useAvailabilityExceptions = function (ids) {
    // We need to refetch when fromDate changes as well
    return useQuery(['availabilityExceptions', ids], function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, AvailabilityExceptionService.getAll({
                        limit: {
                            offset: 0,
                            // CAUTION - limit should be higher depending on the seed data pool, for demo purposes we leave it like this
                            limit: 1000,
                            sort: [{ field: "id", direction: "DESC" }]
                        },
                        availabilityIds: ids,
                    })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.content || []];
            }
        });
    }); });
};
export var useAvailabilityCalculationResults = function (_a) {
    var queryKey = _a.queryKey, entityIds = _a.entityIds, dateRangeFrom = _a.dateRangeFrom, dateRangeTo = _a.dateRangeTo, setEvents = _a.setEvents, sectorsShowCalendarAvailability = _a.sectorsShowCalendarAvailability, sector = _a.sector, keepPreviousData = _a.keepPreviousData;
    return useQuery({
        queryKey: queryKey,
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var isAllowed, data, sortedData, events;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!entityIds)
                            return [2 /*return*/, []];
                        if (sectorsShowCalendarAvailability) {
                            isAllowed = sectorsShowCalendarAvailability.includes(sector === null || sector === void 0 ? void 0 : sector.sectorType);
                            if (!isAllowed)
                                return [2 /*return*/, []];
                        }
                        return [4 /*yield*/, AvailabilityCalculationService.calculate({
                                ids: entityIds,
                                range: {
                                    start: dateRangeFrom,
                                    end: dateRangeTo
                                }
                            })
                            // Sorting by availability type - CLOSED have the priority
                        ];
                    case 1:
                        data = _a.sent();
                        sortedData = sortAvailabilitiesByAvailabilityType(data);
                        events = sortedData.map(function (calc) {
                            var name = calc.name ? "".concat(calc.name).concat(calc.capacityOverride != null ? " (".concat(calc.capacityOverride, ")") : '', " \u270F\uFE0F") : 'Available';
                            return {
                                start: calc.startTime,
                                end: calc.endTime,
                                title: [name, calc.exceptionId ? '**' : ''].filter(Boolean).join(' '),
                                id: calc.id,
                                color: calc.color,
                            };
                        });
                        // console.log("events", events, dateRangeTo.getDay())
                        if (setEvents) {
                            setEvents(events);
                        }
                        return [2 /*return*/, sortedData];
                }
            });
        }); },
        enabled: !!(entityIds === null || entityIds === void 0 ? void 0 : entityIds.length) && !!dateRangeFrom && !!dateRangeTo,
        keepPreviousData: keepPreviousData,
    });
};
